import { ClientSite } from '../models/clientsite';

export interface Title {
    value: string;
    viewValue: string;
}

export class SitePermissionInfo {
    isPermitted: boolean;
    siteInfo: ClientSite;

    constructor(isPermitted: boolean, siteInfo: ClientSite) {
        this.isPermitted = isPermitted;
        this.siteInfo = siteInfo;
    }
}

export class DefaultSiteSelectionInfo {
    siteId: number;
    isDefault: boolean;

    constructor(siteId: number, isDefault: boolean) {
        this.siteId = siteId;
        this.isDefault = isDefault;
    }
}
